import { z } from 'zod';
export const ErrorCodeSchema = z.enum([
    'VALIDATION_ERROR',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'INTERNAL',
    'BOOTSTRAP_REQUIRED',
    'SETUP_REQUIRED',
    'SERVICE_UNAVAILABLE',
    'TOO_MANY_REQUESTS',
]);
export const ApiErrorSchema = z.object({
    error: z.object({
        code: ErrorCodeSchema,
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
export const UuidSchema = z.string().uuid();
//# sourceMappingURL=common.js.map